import React, {useEffect, useState} from 'react';
import {useParams, useSearchParams} from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

import Header from "../../components/layout/Header";
import PageTitle from "../../components/layout/PageTitle";
import Wrapper from "../../components/layout/Wrapper";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBook,
    faClock,
    faCode,
    faPerson,
    faStar,
    faBrain
} from '@fortawesome/free-solid-svg-icons';

import Footer from "../../components/layout/Footer";
import {Helmet} from "react-helmet-async";
import {COURSE_API_BASE, SITE_URL} from "../../utils/apiConfig";
import Breadcrumb from "../../components/layout/Breadcrumb";
import ResponsiveImage from "../../components/elements/ResponsiveImage";
import Button from "../../components/elements/Button";
import {useAuth} from "../../context/AuthProvider";
import Toast from "../../components/layout/Toast";


const CoursePage = () => {

    const {
        isAuthenticated,
    } = useAuth();

    const {course_id} = useParams();

    const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);


    const navigate = useNavigate();

    const [toast, setToast] = useState(null);

    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (
            isAuthenticated &&
            searchParams.get("enroll") === "1"
        ) {
            handleEnroll();
        }
    }, [isAuthenticated]);

    const handleEnroll = async () => {
        if (!isAuthenticated) {
            navigate(`/fa/auth?redirect=/fa/course/${course_id}&enroll=1`);
            return;
        }

        try {
            await axios.post(`${COURSE_API_BASE}/enroll/${course_id}`, {},{
                withCredentials: true
            });
            navigate(`/fa/account/course/${course_id}/content`);
        } catch (error) {

        }
    };
    useEffect(() => {
        const fetchCourse = async () => {

            setLoading(true);
            setError(null);

            try {
                const response = await axios.get(`${COURSE_API_BASE}/${course_id}`);

                const courseData = response.data?.course;


                if (response.data?.success && courseData) {
                    setCourse(courseData);
                } else {
                    setError("دوره پیدا نشد");
                }
            } catch (error) {
            } finally {
                setLoading(false);
            }
        };

        if (course_id) {
            fetchCourse();
        }
    }, [course_id]);

    const getDifficulty = (difficulty) => {

        switch (difficulty) {

            case 0:
                return 'مبتدی';

            case 1:
                return 'متوسط';

            case 2:
                return 'حرفه‌ای';

            default:
                return '';

        }
    };


    if (loading) {

        return (
            <div className="min-h-screen flex flex-col">

                <Header/>

                <main className="flex-1 my-8">

                    <Wrapper>

                        <div className="flex justify-center items-center py-32">

                            <span className="text-lg text-gray-500">
                                در حال بارگذاری دوره...
                            </span>

                        </div>

                    </Wrapper>

                </main>

                <Footer/>

            </div>
        );

    }


    if (error || !course) {

        return (
            <div className="min-h-screen flex flex-col">

                <Header/>

                <main className="flex-1 my-8">

                    <Wrapper>

                        <div className="flex justify-center items-center py-32">

                            <span className="text-lg text-gray-500">
                                دوره مورد نظر پیدا نشد.
                            </span>

                        </div>

                    </Wrapper>

                </main>

                <Footer/>

            </div>
        );

    }


    const breadcrumbItems = [
        {
            link: '/fa/course',
            title: 'دوره‌ها'
        },
        {
            link: `/fa/course/${course.id}`,
            title: course.title
        }
    ];


    return (
        <>
            <Helmet>

                <title>
                    {course.title} | کدپرو
                </title>

                <link
                    rel="canonical"
                    href={`${SITE_URL}/course/${course.id}`}
                />

                <meta
                    name="description"
                    content={course.description || `دوره آموزش ${course.title} در کدپرو`}
                />

            </Helmet>


            <div className="min-h-screen flex flex-col">

                <Header/>


                <main className="flex-1 my-8">

                    <Breadcrumb
                        items={breadcrumbItems}
                    />


                    <Wrapper>

                        <PageTitle
                            title={course.title}
                        />


                        <div className="flex flex-1 w-full mt-2 gap-5">


                            {/* Main Content */}

                            <div className="w-full lg:w-1/2 flex flex-col gap-5">

                                {/* Course image */}

                                <ResponsiveImage
                                    className="rounded-md"
                                    src={course.image}
                                    alt={course.title}/>


                                {/* Difficulty */}

                                {getDifficulty(course.difficulty) && (

                                    <div className="flex items-center gap-2 text-gray-700">

                                        <FontAwesomeIcon
                                            icon={faBrain}
                                        />

                                        <span>
                                            سطح دوره:
                                        </span>

                                        <strong>
                                            {getDifficulty(course.difficulty)}
                                        </strong>

                                    </div>

                                )}


                                {/* Description */}

                                <h2 className="mt-3 mb-2 text-2xl font-bold">
                                    توضیحات
                                </h2>

                                <p className="text-lg text-gray-800 leading-9 whitespace-pre-line">
                                    {course.description}
                                </p>


                                {/* Syllabus */}

                                <h2 className="mt-8 mb-3 text-2xl font-bold">
                                    سرفصل‌ها
                                </h2>


                                {Array.isArray(course.syllabus) &&
                                course.syllabus.length > 0 ? (

                                    <ul className="flex flex-col text-lg w-full gap-3">

                                        {course.syllabus.map((item, index) => (

                                            <li
                                                key={index}
                                                className="border-b border-gray-200 pb-3"
                                            >
                                                {typeof item === 'string'
                                                    ? item
                                                    : item?.title || item?.name || ''}
                                            </li>

                                        ))}

                                    </ul>

                                ) : (

                                    <p className="text-gray-500">
                                        سرفصلی برای این دوره ثبت نشده است.
                                    </p>

                                )}

                            </div>


                            {/* Course Information */}

                            <div
                                className="
                                    w-full lg:w-1/3
                                    h-fit
                                    sticky
                                    top-32
                                    rounded-lg
                                    bg-gray-100
                                    mr-auto
                                    border-2
                                    border-gray-200
                                    flex-col
                                    p-2
                                "
                            >


                                {/* Users */}

                                <div
                                    className="
                                        w-full
                                        flex
                                        justify-between
                                        items-center
                                        p-5
                                        border-b-2
                                        border-gray-200
                                    "
                                >

                                    <span className="block font-bold text-lg">
                                        تعداد کاربران
                                    </span>

                                    <span>
                                        <span>
                                            {course.users ?? '-'}
                                        </span>

                                        <FontAwesomeIcon
                                            icon={faPerson}
                                            size="md"
                                            className="mr-2"
                                        />
                                    </span>

                                </div>


                                {/* Lessons */}

                                <div
                                    className="
                                        w-full
                                        flex
                                        justify-between
                                        items-center
                                        p-5
                                        border-b-2
                                        border-gray-200
                                    "
                                >

                                    <span className="block font-bold text-lg">
                                        تعداد درسنامه
                                    </span>

                                    <span>
                                        <span>
                                            {course.lessons ?? 0}
                                        </span>

                                        <FontAwesomeIcon
                                            icon={faBook}
                                            size="md"
                                            className="mr-2"
                                        />
                                    </span>

                                </div>


                                {/* Projects */}

                                <div
                                    className="
                                        w-full
                                        flex
                                        justify-between
                                        items-center
                                        p-5
                                        border-b-2
                                        border-gray-200
                                    "
                                >

                                    <span className="block font-bold text-lg">
                                        تعداد پروژه
                                    </span>

                                    <span>
                                        <span>
                                            {course.projects ?? 0}
                                        </span>

                                        <FontAwesomeIcon
                                            icon={faCode}
                                            size="md"
                                            className="mr-2"
                                        />
                                    </span>

                                </div>


                                {/* Category */}

                                <div
                                    className="
                                        w-full
                                        flex
                                        justify-between
                                        items-center
                                        p-5
                                        border-b-2
                                        border-gray-200
                                    "
                                >

                                    <span className="block font-bold text-lg">
                                        دسته‌بندی
                                    </span>

                                    <span>
                                        {course.category || '-'}
                                    </span>

                                </div>



                                <Button className="w-full m-2" onClick={handleEnroll}>
                                    {
                                        isAuthenticated ? (
                                            <span>برو به دوره</span>
                                        ) : (<span>ثبت‌نام در دوره</span>)
                                    }
                                </Button>

                            </div>

                        </div>

                        <Toast toast={toast} />
                        <div className="flex flex-col blog flex-1 w-full mt-10" id="course-text">
                            {course.course_text || ""}
                        </div>

                    </Wrapper>

                </main>


                <Footer/>

            </div>
        </>
    )
        ;
};


export default CoursePage;